import { Outlet, Link, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/Logo";
import { Grid3x3, History, LogOut } from "lucide-react";

const nav = [
  { to: "/waiter", label: "Mesas", icon: Grid3x3, end: true },
  { to: "/waiter/history", label: "Historial", icon: History },
];

export default function WaiterLayout() {
  const { user, logout } = useAuth();
  const loc = useLocation();
  return (
    <div className="min-h-screen bg-[#fcfbfd] has-bottom-nav" data-testid="waiter-layout">
      <header className="sticky top-0 z-30 backdrop-blur-xl bg-[#fcfbfd]/85 border-b border-[#b182ec]/30">
        <div className="flex items-center justify-between px-4 h-16 max-w-3xl mx-auto">
          <div className="flex items-center gap-3">
            <Logo size={40} variant="plain" />
            <div>
              <p className="font-display text-base font-bold text-[#1a0f2e] leading-none">oRdeN</p>
              <p className="text-[10px] uppercase tracking-[0.25em] text-[#7248ae]">{user?.name}</p>
            </div>
          </div>
          <Button variant="ghost" size="sm" onClick={logout} className="text-[#3e166c]" data-testid="waiter-logout-button">
            <LogOut className="h-4 w-4" />
          </Button>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 py-4">
        <Outlet />
      </main>

      <nav
        className="bg-white/95 backdrop-blur-xl border-t border-[#b182ec]/30"
        data-testid="waiter-bottom-nav"
        style={{
          position: "fixed",
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 30,
          paddingBottom: "env(safe-area-inset-bottom)",
          transform: "translateZ(0)",
          WebkitTransform: "translateZ(0)",
        }}
      >
        <div className="grid grid-cols-2 px-4 py-2 max-w-3xl mx-auto">
          {nav.map(n => {
            const Icon = n.icon;
            const active = n.end ? loc.pathname === n.to : loc.pathname.startsWith(n.to);
            return (
              <Link key={n.to} to={n.to}
                className={`flex flex-col items-center gap-1 py-2 rounded-xl ${active ? "text-[#3e166c]" : "text-[#7248ae]"}`}>
                <Icon className="h-5 w-5" />
                <span className="text-xs font-medium">{n.label}</span>
              </Link>
            );
          })}
        </div>
      </nav>
    </div>
  );
}
